<template>
  <header class="main-menu">
    <div class="container">
      <section class="main-menu__logo">
        <div class="logo__container">
          <a href="/" class="logo">
            <img src="../assets/logo.png">
          </a>
        </div>
        <div class="btn__container">
          <a href="https://platform.mysequire.com/signup" class="button" target="_blank">
            Join NOW
          </a>
        </div>
      </section>
    </div>
  </header>
</template>

<style lang="scss" scoped>
  @import '@/styles/components/headmenu.scss';
</style>

<script>

export default {
  name: 'headmenu',
};
</script>